<template>
  <div class="fm-list-scroll" @click.self="$emit('select', null)">
    <table class="fm-list-table">
      <thead>
        <tr>
          <th class="fm-th-check"><input type="checkbox" @change="toggleAll" :checked="allSelected" /></th>
          <th @click="$emit('set-sort', 'name')" class="fm-th-sortable">
            Nombre <span v-if="sortBy === 'name'" class="fm-sort-ind">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="$emit('set-sort', 'views_count')" class="fm-th-sortable">
            <v-icon size="18" color="#576080">mdi-eye</v-icon> <span v-if="sortBy === 'views_count'" class="fm-sort-ind">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="$emit('set-sort', 'createdBy')" class="fm-th-sortable">
            Creado Por <span v-if="sortBy === 'createdBy'" class="fm-sort-ind">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="$emit('set-sort', 'updated_at')" class="fm-th-sortable">
            Modificado <span v-if="sortBy === 'updated_at'" class="fm-sort-ind">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="$emit('set-sort', 'size')" class="fm-th-sortable">
            Tamaño <span v-if="sortBy === 'size'" class="fm-sort-ind">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="$emit('set-sort', 'ext')" class="fm-th-sortable">
            Tipo <span v-if="sortBy === 'ext'" class="fm-sort-ind">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th v-if="showDeleted" @click="$emit('set-sort', 'deletedBy')" class="fm-th-sortable">
            Eliminado <span v-if="sortBy === 'deletedBy'" class="fm-sort-ind">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <FMItemCard
          v-for="item in items"
          :key="item.uid"
          :item="item"
          :selected="selected.includes(item.uid)"
          :drag-target="dragTarget === item.uid"
					:showDeleted="showDeleted"
          view="list"
          @open="$emit('open', item)"
          @select="$emit('select', item.uid)"
          @select-only="$emit('select-only', item.uid)"
          @context="$emit('context', $event)"
          @drag-start="$emit('drag-start', $event)"
          @drag-over-item="$emit('drag-over-item', $event)"
          @drop-on-item="$emit('drop-on-item', $event)"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import FMItemCard from './FMItemCard.vue'
export default {
  name: 'FMList',
  components: { FMItemCard },
  props: { items: Array, selected: Array, sortBy: String, sortDir: String, dragTarget: String, showDeleted: Boolean },
  computed: {
    allSelected() { return this.items.length > 0 && this.items.every(i => this.selected.includes(i.uid)) }
  },
  methods: {
    toggleAll(e) {
      if (e.target.checked) this.items.forEach(i => { if (!this.selected.includes(i.uid)) this.$emit('select', i.uid) })
      else this.items.forEach(i => { if (this.selected.includes(i.uid)) this.$emit('select', i.uid) })
    }
  }
}
</script>

<style scoped>
.fm-list-scroll { flex: 1; overflow-y: auto; padding: 0 20px 20px; }
.fm-list-table { width: 100%; border-collapse: collapse; }
thead { position: sticky; top: 0; background: var(--fm-bg); z-index: 2; }
th {
  padding: 10px 12px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--fm-text2);
  border-bottom: 1px solid var(--fm-border);
  white-space: nowrap;
}
.fm-th-sortable { cursor: pointer; user-select: none; }
.fm-th-sortable:hover { color: var(--fm-text); }
.fm-th-check { width: 40px; }
.fm-sort-ind { color: var(--fm-primary); margin-left: 4px; font-weight: 700; }
</style>
